import type { IUpdateVoucherDesignCmd } from "@/data/commands/location/UpdateVoucherDesignCmd";
import { Factory } from "@/data/dao/Factory";
import type { DaoError } from "@/data/dao/service/BaseServiceDao";
import { LocationDao } from "@/data/dao/service/LocationDao";
import type { ILocationDetail } from "@/data/model/Location";

import { type VueComponentInstance, createVueComponent } from "@/shared/utils/vue";

import VoucherDesignEditForm from "@/portal/components/vouchers/VoucherDesignEditForm.vue";
import { BaseEntityForm } from "@/portal/forms/BaseEntityForm";

export class VoucherDesignForm extends BaseEntityForm<ILocationDetail, IUpdateVoucherDesignCmd> {
    private dao: LocationDao;
    private locationId?: string;

    private htmlEditor: VueComponentInstance<typeof VoucherDesignEditForm>;
    private sendTestEmailWithPDFBtn: JQuery;
    private removeVoucherTemplateBtn: JQuery;

    constructor(element: JQuery) {
        super(element, {
            getSingle: undefined as any,
            create: undefined as any,
            getData: undefined as any,
            remove: undefined as any,
            update: (i, d) => Factory.getInstance<LocationDao>(LocationDao).setVoucherDesign(i, d),
        });

        this.dao = Factory.getInstance<LocationDao>(LocationDao);

        this.sendTestEmailWithPDFBtn = this.$form.find("#send-test-email");
        this.removeVoucherTemplateBtn = this.$form.find(".delete-voucher-template-btn").hide();

        const componentResult = createVueComponent(
            VoucherDesignEditForm,
            {
                removeVoucherTemplateBtn: this.removeVoucherTemplateBtn,
            },
            this.$form.find(".voucher-design-form")[0]
        );
        this.htmlEditor = componentResult.mountedComponent;

        this.sendTestEmailWithPDFBtn.on("click", async (event: Event) => {
            event.preventDefault();
            event.stopPropagation();

            const html = componentResult.mountedComponent.getData();
            await this.dao.sendTestEmailWithVoucher(this.locationId!, {
                voucherDesignHtml: html!.htmlTemplate,
                emailAddress: "kuhn.krzysztof@gmail.com",
            });
        });

        this.sendTestEmailWithPDFBtn.hide();
    }

    public setFormData(model?: ILocationDetail) {
        this.locationId = model?.id;
        this.htmlEditor.setFormData(model?.voucherDesign, this.locationId!, model);
    }

    public getFormData(): IUpdateVoucherDesignCmd | undefined {
        let hasError = false;
        if (!this.htmlEditor.validate()) {
            hasError = true;
        }

        if (hasError) {
            this.scrollToFirstErrorField();
        }

        const data: IUpdateVoucherDesignCmd | undefined = this.htmlEditor.getData();

        return hasError ? undefined : data;
    }

    protected resolveErrorMessage(e, b: DaoError): string | undefined {
        return this.htmlEditor.resolveErrorMessage(e, b);
    }
}
